<template>
  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" fill="none" viewBox="0 0 56 56">
    <title>Small illustration of an elderly woman with magenta glasses</title>
    <ellipse cx="24.417" cy="35.201" fill="#05070F" rx="1.917" ry="2" />
    <path
      stroke="#FF0064"
      stroke-linecap="round"
      stroke-width="2"
      d="M20.583 37.201c0 1.933 1.502 3.5 3.355 3.5v0c1.852 0 3.354-1.567 3.354-3.5M29.208 37.201c0 1.933 1.502 3.5 3.355 3.5v0c1.852 0 3.354-1.567 3.354-3.5"
    />
    <ellipse cx="33.042" cy="35.201" fill="#05070F" rx="1.917" ry="2" />
    <path stroke="#FF0064" stroke-linecap="round" stroke-width="2" d="M20.583 37.201h15.334" />
    <path
      stroke="#05070F"
      stroke-linecap="square"
      stroke-width="2"
      d="M18.842 13.701S21.116 5 28.25 5c7.134 0 9.433 8.701 9.433 8.701"
    />
    <path
      stroke="#05070F"
      stroke-width="2"
      d="M39.928 39.94c3.415-1.995 5.572-5.222 5.572-9.967 0-9.033-6.743-18.434-17.575-18.434-10.832 0-16.925 9.4-16.925 18.434 0 4.994 2.39 8.307 6.12 10.27"
    />
    <path
      fill-rule="evenodd"
      stroke="#05070F"
      stroke-linejoin="round"
      stroke-width="2"
      d="M33.826 26.353s-4.851 3.355-8.162 3.946c-3.31.591-10.539-.61-10.539-.61s1.741 11.51 3.456 14.262c5.059 8.117 10.148 7.567 10.148 7.567s3.85.329 8.829-6.342c1.483-1.986 3.73-10.976 3.73-10.976s-3.301-1.207-4.574-2.621c-1.273-1.415-2.888-5.226-2.888-5.226z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CompanionCareIcon',
  props: {
    width: {
      default: 56,
      required: false,
      type: Number,
    },
    height: {
      default: 56,
      required: false,
      type: Number,
    },
  },
};
</script>
